<template>
    <div :id="idName" :class="'column ' + className">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                default: "",
                type: String,
            },
            className: {
                default: "",
                type: String,
            },
            idName: {
                default: "",
                type: String,
            }
        }
    }
</script>